import { render, staticRenderFns } from "./ChangeRecord.vue?vue&type=template&id=aa42b790&scoped=true&"
import script from "./ChangeRecord.vue?vue&type=script&lang=js&"
export * from "./ChangeRecord.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRecord.vue?vue&type=style&index=0&id=aa42b790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa42b790",
  null
  
)

export default component.exports